<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.HistoricalAnomaly')"
    width="750px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
  </el-dialog>
</template>

<script>

export default {
  name: 'ErrorLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Message.TimeOfOccurrence'),
          field: 'TIME',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Describe'),
          field: 'CONTENT',
          width: 520
        }
      ],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  }
}
</script>

<style>
</style>
